import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Logo } from "@/components/Navbar";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300">
      <div className="max-w-7xl mx-auto px-5 py-14">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="brightness-0 invert opacity-90 w-fit"><Logo /></div>
            <p className="mt-3 text-base font-semibold text-white">Vos appels d'offres, servis chaque matin.</p>
            <p className="mt-2 text-sm text-slate-400 max-w-sm leading-relaxed">
              Les marchés publics faits pour vous, sélectionnés chaque matin.
              Une plateforme indépendante qui simplifie l'accès des TPE et PME à la commande publique.
            </p>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Marchés par secteur</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li><Link to="/secteurs/communication" className="hover:text-white transition-colors">Communication & Événementiel</Link></li>
              <li><Link to="/secteurs/batiment" className="hover:text-white transition-colors">Second œuvre & Rénovation</Link></li>
              <li><Link to="/secteurs/numerique" className="hover:text-white transition-colors">Numérique & Cybersécurité</Link></li>
              <li><Link to="/secteurs" className="hover:text-white transition-colors">Tous les départements</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold mb-3 text-sm">Conformité</h4>
            <ul className="space-y-2 text-sm text-slate-400">
              <li>Licence Ouverte Etalab 2.0</li>
              <li>Source officielle : BOAMP / DILA</li>
              <li>Hébergement UE, conforme RGPD</li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t border-slate-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} Le Café des Marchés. Données publiques réutilisées sous Licence Ouverte Etalab 2.0.</p>
          <div className="flex items-center gap-2 text-xs text-emerald-400">
            <ShieldCheck className="w-4 h-4" /> Données officielles actualisées deux fois par jour, 7j/7
          </div>
        </div>
      </div>
    </footer>
  );
}
